export type ColorPreset = {
	id: string;
	label: string;
	primaryLight: string;
	primaryDark: string;
	color: string;
};

export const COLOR_PRESETS: ColorPreset[] = [
	{
		id: 'blue',
		label: 'Bleu',
		primaryLight: 'oklch(60% 0.155 240)',
		primaryDark: 'oklch(65% 0.155 240)',
		color: '#3b82f6'
	},
	{
		id: 'red',
		label: 'Rouge',
		primaryLight: 'oklch(55% 0.22 25)',
		primaryDark: 'oklch(60% 0.22 25)',
		color: '#ef4444'
	},
	{
		id: 'green',
		label: 'Vert',
		primaryLight: 'oklch(58% 0.17 149)',
		primaryDark: 'oklch(63% 0.17 149)',
		color: '#22c55e'
	},
	{
		id: 'purple',
		label: 'Violet',
		primaryLight: 'oklch(55% 0.18 300)',
		primaryDark: 'oklch(60% 0.18 300)',
		color: '#a855f7'
	},
	{
		id: 'orange',
		label: 'Orange',
		primaryLight: 'oklch(65% 0.19 55)',
		primaryDark: 'oklch(68% 0.19 55)',
		color: '#f97316'
	},
	{
		id: 'slate',
		label: 'Ardoise',
		primaryLight: 'oklch(50% 0.05 257)',
		primaryDark: 'oklch(55% 0.05 257)',
		color: '#64748b'
	}
];

export function getPresetById(id: string): ColorPreset | undefined {
	return COLOR_PRESETS.find((p) => p.id === id);
}
